document.addEventListener("DOMContentLoaded", () => {
  if (document.body.classList.contains("smatrr-customisation-loaded")) {
    return;
  } else {
    document.body.classList.add("smatrr-customisation-loaded");
  }
  const paymentsNames = document.querySelectorAll(
    ".smartrr-selling-plan-group-name"
  );

  paymentsNames.forEach((paymentName) => {
    const paymentNameArr = paymentName
      .querySelector("div")
      .textContent.split("&");
    // console.log(paymentNameArr);
    if (paymentNameArr.length > 1) {
      paymentName.querySelector("div").innerHTML =
        paymentNameArr[0] +
        ` & ` +
        `<span class="payment-red-text">${paymentNameArr[1]}</span>`;
    }
  });
  const otpPlans = document.querySelectorAll(
    "[data-smartrr-selling-plan-group-id].smartrr-otp"
  );
  const subscriptionPlans = document.querySelectorAll(
    "[data-smartrr-selling-plan-group-id]:not(.smartrr-otp)"
  );
  subscriptionPlans.forEach((plan) => {
    const div = document.createElement("div");
    div.classList.add("subscribtion-messages");
    div.innerHTML = `
        <div class="subscription-delivery-info">
        <img src="https://cdn.shopify.com/s/files/1/0054/1582/files/reocurring-icon_1.png?v=1711876572" width="23" height="23" defer>

        <p> 3 month supply  delivered every <span class="subscription-months">1 months</span>  </p>
        </div>
        <div class="subscription-cancel-info">
        <img src="https://cdn.shopify.com/s/files/1/0054/1582/files/play-pause_1_1.png?v=1711876439" width="23" height="23" defer>
        <p>Pause, skip, or cancel any time</p>
        </div>
    `;

    plan.appendChild(div);
    const select = plan.querySelector(
      "select[data-smartrr-selling-plans-select]"
    );
    if (select) {
      select.addEventListener("change", () => {
        // console.log("I am registering select change");
        const subscriptionMonths = plan.querySelectorAll(
          ".subscription-months"
        );

        const selectedOption = select.querySelector(
          `option[value="${select.value}"]`
        );
        if (selectedOption)
          subscriptionMonths.forEach(
            (month) =>
              (month.innerHTML = selectedOption.textContent.replace(
                "Deliver Every ",
                ""
              ))
          );
      });

      const chevronContainer = select
        .closest("section")
        .querySelector(".svg-icon-chevron");
      const chevtonIcon = document.createElement("span");
      chevtonIcon.classList.add("chevron-icon");
      chevtonIcon.innerHTML = chevronContainer.innerHTML;
      if (
        !select
          .closest("[data-smartrr-selling-plan-group-plans]")
          .querySelector(".chevron-icon")
      ) {
        select
          .closest("[data-smartrr-selling-plan-group-plans]")
          .appendChild(chevtonIcon);
      }
    }
  });

  otpPlans.forEach((plan) => {
    const header = plan.querySelector(".smartrr-selling-plan-group-header");
    if (header) {
      const div = document.createElement("div");
      div.classList.add("cost-ppu");
      const mainSection = plan.closest("section.section");
      div.innerHTML = mainSection.querySelector(".otp-ppu").innerHTML;
      header.appendChild(div);
    }
  });
  subscriptionPlans.forEach((plan) => {
    const header = plan.querySelector(".smartrr-selling-plan-group-header");
    if (header) {
      const div = document.createElement("div");
      div.classList.add("cost-ppu");
      const mainSection = plan.closest("section.section");
      div.innerHTML = mainSection.querySelector(".subscrption-ppu").innerHTML;
      header.appendChild(div);
    }

    const select = plan.querySelector("select");
    const label = plan.querySelector(".smartrr-plans-frequency-label");
    if (select) {
      const options = select.querySelectorAll("option");
      let value = null;
      options.forEach((option) => {
        if (option.textContent.includes("3 months")) {
          value = option.value;
        }
        if (label) {
          option.innerHTML = label.textContent + " " + option.innerHTML;
        }
      });
      // if (value) {
      //   plan.querySelector(".smartrr-selling-plan-group-input-display").click();
      //   select.value = value;
      //   select.dispatchEvent(new Event("change"), { bubbles: true });
      // }
    }
  });

  otpPlans.forEach((plan) => {
    const otpMessage = plan
      .closest("section.section")
      .querySelector(".otp-option-message");

    if (!otpMessage) return;
    const div = document.createElement("div");
    div.classList.add("otp-message");
    div.innerHTML = otpMessage.innerHTML;
    plan.appendChild(div);
  });

  const allPlans = document.querySelectorAll(
    "[data-smartrr-selling-plan-group-id]"
  );
  allPlans.forEach((plan) => {
    plan.addEventListener("click", () => {
      if (plan.classList.contains("smartrr-group-active")) {
        return;
      }
      plan.querySelector(".smartrr-selling-plan-group-input-display").click();
    });
  });

  //price change
  const inputsSelects = document.querySelectorAll(
    "[data-smartrr-selling-plan-group-input],[data-smartrr-selling-plans-select]"
  );
  inputsSelects.forEach((el) => {
    el.addEventListener("change", () => {
      const parent = el.closest(".product__information");
      if (!parent) {
        return;
      }
      const activePlan = parent.querySelector(".smartrr-group-active");
      if (!activePlan) {
        return;
      }
      const atc = parent.querySelector(".button--add-to-cart .text");
      if (!atc) {
        return;
      }
      const price = activePlan.querySelector("[data-smartrr-subscribe-price]");
      if (!price) {
        return;
      }
      atc.textContent = "Add to bag / " + price.textContent + " ";
    });
  });

  setTimeout(() => {
    const activePlans = document.querySelectorAll(".smartrr-group-active");
    activePlans.forEach((activePlan) => {
      if (activePlan) {
        const input = activePlan.querySelector("input");
        input.dispatchEvent(new Event("change"), { bubbles: true });
      }
    });
  }, 2000);
});
